import { useEffect, useRef, useState } from 'react';
import './timeSelector.scss';

interface TimeDropDown {
  columnWidth: number;
  isOpen: boolean;
  onTimeSelect: any;
  xTranslation: number;
  startTime: string;
}

export const TimeDropdown = ({ columnWidth = 150, isOpen, onTimeSelect, xTranslation, startTime }: TimeDropDown) => {
  const [selectedHour, setSelectedHour] = useState(startTime.split(':')[0] || '00');
  const [selectedMinute, setSelectedMinute] = useState(startTime.split(':')[1] || '00');
  const [selectedSecond, setSelectedSecond] = useState(startTime.split(':')[2] || '00');

  useEffect(() => {
    startTime.split(':');
    setSelectedHour(startTime.split(':')[0]);
    setSelectedMinute(startTime.split(':')[1]);
    setSelectedSecond(startTime.split(':')[2]);
  }, [startTime]);

  const hourRef = useRef(null);
  const minuteRef = useRef(null);
  const secondRef = useRef(null);

  const scrollToSelected = (ref: any, selectedValue: any) => {
    if (ref.current) {
      const element = ref.current.querySelector(`.option[data-value="${selectedValue}"]`);
      if (element) {
        ref.current.scrollTop = element.offsetTop - ref.current.offsetTop;
      }
    }
  };
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        scrollToSelected(hourRef, selectedHour);
        scrollToSelected(minuteRef, selectedMinute);
        scrollToSelected(secondRef, selectedSecond);
      }, 0);
    }
  }, [isOpen, selectedHour, selectedMinute, selectedSecond]);

  const generateOptions = (max: number) => Array.from({ length: max + 1 }, (_, i) => i.toString().padStart(2, '0'));

  const handleSelection = (type: string, value: string) => {
    if (type === 'hour') setSelectedHour(value);
    if (type === 'minute') setSelectedMinute(value);
    if (type === 'second') setSelectedSecond(value);

    onTimeSelect({
      hour: type === 'hour' ? value : selectedHour,
      minute: type === 'minute' ? value : selectedMinute,
      second: type === 'second' ? value : selectedSecond,
    });
  };

  return (
    <>
      {isOpen && (
        <div
          className="dropdown"
          style={{
            gridTemplateColumns: `repeat(3, ${columnWidth}px)`,
            transform: `translateX(${xTranslation}px)`,
          }}
        >
          <div className="dropdown-column">
            <label>Hours</label>
            <div className="scrollable-list" style={{ width: `${columnWidth}px` }} ref={hourRef}>
              {generateOptions(23).map((hour) => (
                <div key={hour} data-value={hour} className={`option ${selectedHour === hour ? 'selected' : ''}`} onClick={() => handleSelection('hour', hour)}>
                  {hour}
                </div>
              ))}
            </div>
          </div>
          <div className="dropdown-column">
            <label>Minutes</label>
            <div className="scrollable-list" style={{ width: `${columnWidth}px` }} ref={minuteRef}>
              {generateOptions(59).map((minute) => (
                <div
                  key={minute}
                  data-value={minute}
                  className={`option ${selectedMinute === minute ? 'selected' : ''}`}
                  onClick={() => handleSelection('minute', minute)}
                >
                  {minute}
                </div>
              ))}
            </div>
          </div>
          <div className="dropdown-column">
            <label>Seconds</label>
            <div className="scrollable-list" style={{ width: `${columnWidth}px` }} ref={secondRef}>
              {generateOptions(59).map((second) => (
                <div
                  key={second}
                  data-value={second}
                  className={`option ${selectedSecond === second ? 'selected' : ''}`}
                  onClick={() => handleSelection('second', second)}
                >
                  {second}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TimeDropdown;
